import { memo } from 'react';
import type { JSX } from 'react';
import cn from 'classnames';
import { TagColour } from '@adapters/bigcommerce/types/product';

import styles from './Tag.module.scss';

interface TagProps {
  component?: JSX.Element | null;
  tagText?: string;
  colourOverride?: TagColour | null;
}

const Tag = ({ component, tagText, colourOverride }: TagProps) => {
  if (!component && !tagText) {
    return null;
  }
  return (
    <>
      <span
        className={cn(styles.tag, {
          [styles.hoverState]: component?.type && component?.type !== 'span',
          [styles.red]: colourOverride === TagColour.red,
          [styles.black]: colourOverride === TagColour.black,
          [styles.redOutline]: colourOverride === TagColour.redOutline,
        })}
      >
        {component || tagText}
      </span>
    </>
  );
};

export default memo(Tag);
